import { Context } from 'Context/Context';
import React, { useContext, useState } from 'react'
import { getNetWorth } from 'Utils';

function PremiumInfo({detail, attorney}) {
    const [onHover, setOnHover] = useState(false);
    const [onHover1, setOnHover1] = useState(false);
    const [onHover2, setOnHover2] = useState(false);
    const [onHover3, setOnHover3] = useState(false);
    const {userDetails} = useContext(Context);
    const userInfo = attorney ? attorney.userId : userDetails;
    const [onHover4, setOnHover4] = useState(false);
  const [onHoverReview, setOnHoverReview] = useState(false);

  return (
    <>
    {userInfo?.isActiveSubscription ? 
    <div className='flex w-full  flex-wrap gap-2 text-xs items-center relative'>
        <div className='flex w-max text-xs rounded items-center relative'>
        {
            
            <>
                <div 
                    onMouseEnter={() => setOnHover(true)}
                    onMouseLeave={() => setOnHover(false)}
                    className={
                        'flex font-bold lg:mr-2 rounded-full p-1 px-2 w-max text-purple-600 lg:mr-2 border-purple-600 border cursor-pointer bg-purple-50'
                        
                        // (detail?.isClassAction === "yes" ? 'border-green-600 border cursor-pointer bg-green-50' : 'border-red-400 cursor-pointer bg-red-100' )
                        }>
                
                <div>
                    
                Class Action: {detail?.isClassAction === "yes" ? "Yes" : "No"}
                
                </div>
                </div>
                {onHover && 
                <>
                
                <div className='absolute  bg-purple-200 w-max rounded font-medium border border-purple-200 -top-10 p-2'>
                    <div>
                        {detail?.isClassAction === "yes" ? "This case is a class action" : 
                        "This case is not a class action"
                        }
                    </div>
                    <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 absolute -bottom-2"></div> 
                </div></>}
                </>
            
            }
            </div>
        <div className='flex w-max flex-wrap text-xs rounded items-center relative'>

            {
                
                <>
                    <div 
                onMouseEnter={() => setOnHover1(true)}
                onMouseLeave={() => setOnHover1(false)}
                className={
                    'flex font-bold  mr-2 border rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-purple-50'
                    }>
                    <div>
                        Multiple plaintiffs : {detail?.defendant
                         === "yes" ? "Yes" : "No"}
                    
                    </div>
                    </div>
                    {onHover1 && 
                    <>
                    
                    <div className='absolute  bg-purple-200 w-max rounded font-medium border border-purple-200 -top-10 p-2'>
                        <div>
                            {detail?.defendant === "yes" ? "This case has multiple plaintiffs" :
                            "This case does not have multiple plaintiffs"}

                        </div>
                        <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 absolute -bottom-2"></div> 
                    </div></>}
                    </>
                
            }

        </div>
        
        <div className='flex w-max flex-wrap text-xs rounded items-center relative'>

            {
                
                <>
                    <div 
                onMouseEnter={() => setOnHover3(true)}
                onMouseLeave={() => setOnHover3(false)}
                className={
                    'flex font-bold  mr-2 border mb-2 lg:mb-0 rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-purple-50'
                    }>
                    
                    <div>
                        
                
                        Adverse Party Net-worth: {detail?.adversePartyNetWorth ? 
                        getNetWorth(detail?.adversePartyNetWorth) : "Not available"}
                    
                    </div>
                    </div>
                    {onHover3 && 
                    <>
                    
                    <div className='absolute  bg-purple-200 w-max rounded font-medium border border-purple-200 -top-10 p-2'>
                        <div>
                            {detail?.adversePartyNetWorth ? 
                            "The adverse party's net worth is " + getNetWorth(detail?.adversePartyNetWorth) : 
                            "The adverse party's net worth is not available"}

                        </div>
                        <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 absolute -bottom-2"></div> 
                    </div></>}
                    </>
                
            }<div className='flex w-max text-xs mb-2 lg:mb-0 rounded items-center relative'>

            {
            
                <>
                    <div 
                onMouseEnter={() => setOnHover2(true)}
                onMouseLeave={() => setOnHover2(false)}
                className=
                    'flex font-bold  mr-2 border rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-purple-50'
                    >
                    <div>
                        
                    {detail?.isEntity === "yes" ? "Entity" : "Individual"}
                    
                    </div>
                    </div>
                    {onHover2 && 
                    <>
                    
                    <div className='absolute  bg-purple-200 w-max rounded font-medium border border-purple-200 -top-10 p-2'>
                        <div>{
                        detail?.isEntity === "yes" ? "This case is against an entity" : "This case is against an individual"}
                        </div>
                        <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 absolute -bottom-2"></div> 
                    </div></>}
                    </>
            }
        </div>
            {
                detail?.adversePartyPublicCompany &&
                <div
                onMouseEnter={() => setOnHover4(true)}
                onMouseLeave={() => setOnHover4(false)}
                className={
                    'flex font-bold relative  mr-2 rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-purple-50'
                    }>
                    
                    <div>


                        Against Public Company: {detail?.adversePartyPublicCompany === "yes" ? "Yes" : (detail?.adversePartyPublicCompany === "no" ? "No" : "Unknown")}

                    </div>
                    </div>
                }
                {onHover4 &&
                <>
                <div className='absolute  bg-purple-200 w-max rounded font-medium border border
-purple-200  p-2 right-0 -top-10'>
                    <div>
                        {detail?.adversePartyPublicCompany === "yes" ? "The adverse party is a public company" : 
                        (detail?.adversePartyPublicCompany === "no" ? "The adverse party is not a public company" : "Client is unaware of status of the adverse party as a public company")}
                    </div>
                    <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 right-0 absolute -bottom-2"></div>
                </div>
                </>
            }
 
        </div>
       
    </div>
    :
    <div className='flex w-full flex-wrap text-xs items-center gap-2 relative'
    onMouseEnter={() => setOnHover(true)}
    onMouseLeave={() => setOnHover(false)}
    >
        <div className='flex w-max text-xs flex-wrap rounded items-center relative'>
        {
            
            <>
                <div 
            onMouseEnter={() => setOnHover(true)}
            onMouseLeave={() => setOnHover(false)}
            className=
                'flex font-bold  lg:mr-2 rounded-full p-1 px-2 w-max text-purple-600 lg:mr-2 border-purple-600 border cursor-pointer bg-gray-50'
                >
                
                <div>
                    
                Class Action : 
                <span className='blur-sm'>
                    &nbsp;test
                </span>
                </div>
                </div>
                {onHover && 
                <>
                
                <div className='absolute  bg-purple-200 w-max rounded font-medium border border-purple-200 -top-10 p-2'>
                    <div>
                        Subscribe to view this information
                    </div>
                    <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 absolute -bottom-2"></div> 
                </div></>}
                </>
            
            }
            </div> 
            <div className='flex w-max text-xs flex-wrap rounded items-center relative'>
        {
            
            <>
                <div 
           
            className=
                'flex font-bold  mr-2 rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-gray-50'
                >
                
                <div>
                    
                Multiple plaintiffs : 
                <span className='blur-sm'>
                    &nbsp;test
                </span>
                </div>
                </div>
               
                </>
            
            }
            </div> 
            <div className='flex w-max flex-wrap gap-2 text-xs rounded items-center relative'>
        {
            
            <>
                <div 
           
            className=
                'flex font-bold  mr-2 rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-gray-50'
                >
                
                <div>
                    
                Entity/Individual : 
                <span className='blur'>
                    &nbsp;test
                </span>
                </div>
                </div>
                                </>
            
            }
            {
            
            <>
                <div 
           
            className=
                'flex font-bold flex-wrap  mr-2 rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-gray-50'
                >
                
                <div>
                    
                Adverse Party Net-worth : 
                <span className='blur'>
                    &nbsp;test
                </span>
                </div>
                </div>
                                </>
            
            }
            {
                <>
                    <div
                onMouseEnter={() => setOnHover4(true)}
                onMouseLeave={() => setOnHover4(false)}
                className={
                    'flex font-bold  mr-2 rounded-full p-1 px-2 w-max text-purple-600 mr-2 border-purple-600 border cursor-pointer bg-gray-50'
                    }>
                    
                    <div>
                        
                
                        Against Public Company: 
                        <span className='blur'>
                            &nbsp;test
                        </span>
                    
                    </div>
                    </div>
                    {onHover4 && 
                    <>

                    <div className='absolute  bg-purple-200 w-max rounded font-medium border border-purple-200  p-2 right-0 -top-10'>
                        <div>
                            Subscribe to view this information
                        </div>
                        <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-purple-200 h-0 w-0 absolute -bottom-2 right-0"></div> 
                    </div></>}
                </>
            }
            </div>   
    </div>
    }
    </>
  )
}

export default PremiumInfo